import React from 'react';
import PropTypes from 'prop-types';
import { APPLE_SEARCH_ADS_PARTNER_NAME, SAN_PARTNERS } from '../../../consts';
import { organizationOptionsShape, partnerShape, siteShape } from '../../types';
import AttributionPostbacks from './AttributionPostbacks';
import { POSTBACK_FILTERS_TYPES } from '../advancedPostbackSettings/PostbackFilters';

export default function AttributionPostbacksFactory({ partner, site, isReadonly, orgOptions, availableFilters }) {
    if (partner.name === APPLE_SEARCH_ADS_PARTNER_NAME) {
        return (
            <AttributionPostbacks
                orgOptions={orgOptions}
                partner={partner}
                availableFilters={availableFilters}
                site={site}
                isReadonly={isReadonly}
                viewThroughLabel="STATIC.PAGES.PARTNER_CONFIGURATION.SHELF.ATTRIBUTION_SETTINGS.ENABLE_VIEW_THROUGH"
                viewThroughTooltip="STATIC.PAGES.PARTNER_CONFIGURATION.SHELF.ATTRIBUTION_SETTINGS.ENABLE_VIEW_THROUGH_TOOLTIP"
            />
        );
    } else if (SAN_PARTNERS.includes(partner.name)) {
        return (
            <AttributionPostbacks
                orgOptions={orgOptions}
                partner={partner}
                site={site}
                availableFilters={availableFilters}
                isReadonly={isReadonly}
                viewThroughLabel="STATIC.PAGES.PARTNER_CONFIGURATION.SHELF.ATTRIBUTION_SETTINGS.ENABLE_VIEW_THROUGH"
                viewThroughTooltip="STATIC.PAGES.PARTNER_CONFIGURATION.SHELF.ATTRIBUTION_SETTINGS.SAN_SEND_VIEW_THROUGH_TOOLTIP"
            />
        );
    }

    return (
        <AttributionPostbacks
            orgOptions={orgOptions}
            partner={partner}
            site={site}
            isReadonly={isReadonly}
            availableFilters={availableFilters}
        />
    );
}

AttributionPostbacksFactory.propTypes = {
    partner: partnerShape.isRequired,
    site: siteShape.isRequired,
    isReadonly: PropTypes.bool,
    orgOptions: organizationOptionsShape.isRequired,
    availableFilters: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            displayName: PropTypes.string,
            type: PropTypes.oneOf(Object.values(POSTBACK_FILTERS_TYPES)),
        })
    ),
};
